import React, { createContext, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdvertiserAccountQuery } from '../query/dashboardQueries';

const AdvertiserAccountContext = createContext(null);

export function AdvertiserAccountProvider({ children }) {
    const navigate = useNavigate();
    const { data, isLoading, isError } = useAdvertiserAccountQuery();

    useEffect(() => {
        if (!isLoading && data && !data.accountActivated) {
            navigate('/advertiserActivate', { replace: true });
        }
    }, [data, isLoading, navigate]);

    const value = {
        account: data || null,
        isLoading,
        isError,
        accountActivated: Boolean(data?.accountActivated),
    };

    return (
        <AdvertiserAccountContext.Provider value={value}>
            {children}
        </AdvertiserAccountContext.Provider>
    );
}

export function useAdvertiserAccountContext() {
    const ctx = useContext(AdvertiserAccountContext);
    if (!ctx) {
        throw new Error('useAdvertiserAccountContext must be used within AdvertiserAccountProvider');
    }
    return ctx;
}
